import axios from 'axios';

const rawBaseUrl = import.meta.env.VITE_API_URL || import.meta.env.VITE_API_BASE_URL || '';

let baseURL = rawBaseUrl;

// Fallback for environments where the API is reverse-proxied behind the same origin.
if (!baseURL && typeof window !== 'undefined') {
  baseURL = window.location.origin;
}

// Normalize and avoid mixed-content issues in production.
if (typeof baseURL === 'string' && baseURL.length > 0) {
  baseURL = baseURL.replace(/\/$/, '');

  if (typeof window !== 'undefined' && window.location.protocol === 'https:' && baseURL.startsWith('http://')) {
    baseURL = baseURL.replace(/^http:\/\//, 'https://');
  }
}

const api = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);
export default api;
